import React from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import { inject, observer } from "mobx-react";
import LinearProgress from '@material-ui/core/LinearProgress';
import StripeWarning from "./lib/StripeWarning";
import Header from "./lib/Header";
import Login from "./Account/Login";
import ConfirmPassword from "./Account/ConfirmPassword";
//import ForgotPassword from "./Account/ForgotPassword";
//import Logout from "./Account/Logout";
//import Confirm from "./Account/Confirm";
//import Register from "./Account/Register";
//import Settings from "./Account/Settings";
import Home from "./Home";
import Leads from "./Leads";
import Analytics from './Leads/Analytics'
import SessionExpiredDialog from "./SessionExpiredDialog";
import CampaignSetup from './Leads/Campaigns/ManageCampaign/'


@inject("authStore", "commonStore")
@withRouter
@observer
export default class App extends React.Component {
  componentWillMount() {
    //this.props.authStore.verifySession();
    this.props.authStore.loadApp();
  }


  render() {
    const { currentUser, userSessionExpired } = this.props.authStore
    const { appLoading, appLoaded, showHeader, agent, loading, stripeEnv, appEnv } = this.props.commonStore

    const stripeIntest = stripeEnv === 'test'

    if (appLoaded && !appLoading) {
      if (currentUser) {
            if(agent){
              return (
                <div>
                  {stripeIntest ? <StripeWarning appEnv={appEnv}/> : null }
                  <Switch>
                    {/*<Route path="/login" component={Login} />/>*/}
                    {/*<Route path="/register/confirm" component={Confirm} />*/}
                    {/*<Route path="/register" component={Register} />*/}
                    {/*<Route path="/settings" component={Settings} />*/}
                    {/*<Route path="/logout" component={Logout} />*/}
                     {/*<Route path="/campaign" component={CampaignSetup} />*/}
                    {/*<Route path="/analytics" component={Analytics} />>*/}
   
                    <Route path="/" component={Leads} />
                  </Switch>
                  <SessionExpiredDialog open={userSessionExpired}/>
                </div>
              );
            }else{
              //need a dialog
            }
      }else{
        return (
          <div>
            <Header />
            {loading ? <LinearProgress color="secondary" /> : null}
            <Switch>
             {/* <Route path="/forgotpassword" component={ForgotPassword} />*/}
              <Route path="/confirmpassword" component={ConfirmPassword} />
              <Route path="/" component={Login} />
               {/*<Route path="/register/confirm" component={Confirm} />*/}
              {/*<Route path="/register" component={Register} />*/}
            </Switch>
          </div>
        );
      }
    }
    return (
      <div>
      <Header />
      <LinearProgress color="secondary" />
    
      </div>
    )
  }
}
/*
  render() {

        return (
          <div>
            <Switch>
              <Route path="/" component={Home} />
            </Switch>
          </div>
        );
  }
}*/



// WEBPACK FOOTER //
// ./src/components/App.js